import { render, staticRenderFns } from "./TenantHeader.vue?vue&type=template&id=34a827cb&scoped=true"
import script from "./TenantHeader.vue?vue&type=script&lang=js"
export * from "./TenantHeader.vue?vue&type=script&lang=js"
import style0 from "./TenantHeader.vue?vue&type=style&index=0&id=34a827cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a827cb",
  null
  
)

export default component.exports